import React from 'react';
import { Form } from 'react-bootstrap';

interface InputTextProps {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  ClassName?: string;
  Feedback?: string;
  HandleChange: (event: any) => void;
  Id: string;
  IsDisabled?: boolean;
  IsFullWidth?: boolean;
  IsInvalid?: boolean;
  IsReadOnly?: boolean;
  IsRequired?: boolean;
  IsTextArea?: boolean;
  Label?: string;
  Name?: string;
  Placeholder?: string;
  Value?: string;
}

const InputText = ({
  ClassName = 'mb-24',
  Feedback = null,
  HandleChange,
  Id = null,
  IsDisabled = false,
  IsFullWidth = false,
  IsInvalid = false,
  IsReadOnly = false,
  IsRequired = true,
  IsTextArea = false,
  Label = null,
  Name = null,
  Placeholder = null,
  Value = null,
}: InputTextProps) => {
  return (
    <Form.Group className={ClassName} id={Id}>
      {Label && (
        <Form.Label className={IsRequired ? 'required' : ''}>
          {Label}
        </Form.Label>
      )}
      <Form.Control
        as={IsTextArea ? 'textarea' : 'input'}
        autoComplete="off"
        className={IsFullWidth ? 'w-100' : ''}
        disabled={IsDisabled}
        id={Id}
        isInvalid={IsInvalid}
        name={Name !== null ? Name : Id}
        onChange={HandleChange}
        placeholder={Placeholder}
        readOnly={IsReadOnly}
        required={IsRequired}
        value={Value}
      />
      {Feedback && IsInvalid && (
        <Form.Control.Feedback type="invalid">{Feedback}</Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

// InputText.defaultProps = {
//   ClassName: 'mb-24',
//   Feedback: null,
//   IsDisabled: false,
//   IsFullWidth: false,
//   IsInvalid: false,
//   IsReadOnly: false,
//   IsRequired: true,
//   IsTextArea: false,
//   Label: null,
//   Name: null,
//   Placeholder: null,
//   Value: null,
// };

export default InputText;
export { InputText };
export type { InputTextProps };
